<template>
  <div class="col-lg-12">
    <ejs-treeview
      ref='measureTreeForDataQueryForResourceReport'
      :fields='fieldsOfMeasureTreeForResourceReport'
      :nodeSelected="measureTreeNodeSelectedForResourceReport"
    ></ejs-treeview>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'NoRealTaskMeasureTreeForResourceReport',
  data() {
    return {
      fieldsOfMeasureTreeForResourceReport: {
        dataSource: [],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      nodeCheckIdForResourceReport: 1,
      nodeCheckInfoForResourceReport: {}

    }
  },
  methods: {

    measureTreeNodeSelectedForResourceReport(args){
      let checkedNode = args.nodeData;
      if(checkedNode.hasChildren == false){
        this.nodeCheckIdForResourceReport = checkedNode.id;
        this.nodeCheckInfoForResourceReport = checkedNode;
      }
    },

    getMeasureTreeForResourceReport(neTypeCode,measureObjCode){
      const params = {
        neTypeCode,
        measureObjCode
      }
      this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskCounterTreeForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fieldsOfMeasureTreeForResourceReport = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    }
  },
  watch: {
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>
